<div class="row my-5">
  <div class="col-4 offset-4">
    <h3>Ponastavitev gesla</h3>

    <div class="alert alert-danger" *ngIf="renewError">
      {{renewError}}
    </div>

    <div class="alert alert-success" *ngIf="renewSuccess">
      Geslo je bilo uspešno ponastavljeno.<br/><br>
      <a [routerLink]="['/login']" style="cursor: pointer">Nadaljujte s prijavo</a>
    </div>

    <form [formGroup]="renewForm" novalidate (submit)="renew(renewForm)" *ngIf="!hideForm">
      <div class="form-group">
        <label for="password">Geslo</label>
        <input type="password" class="form-control" id="password" formControlName="password">
      </div>

      <div class="form-group">
        <label for="password2">Ponovite geslo</label>
        <input type="password" class="form-control" id="password2" formControlName="password2">
      </div>

      <div class="form-group text-right">
        <div class="form-text">
          <a [routerLink]="['/login']" style="cursor: pointer">Nazaj na prijavo</a>
        </div>
      </div>

      <div class="form-group text-right">
        <button type="submit" class="button button-3d button-large button-primary mr-0" [disabled]="renewInProgress">
          <i class="la la-check" *ngIf="!renewInProgress"></i>
          <i class="la la-spin la-spinner" *ngIf="renewInProgress"></i>
          Potrdi
        </button>
      </div>
    </form>
  </div>
</div>
